import { StyleSheet } from 'aphrodite'

import headers from './headers'
import list from './list'
import form from './form'
import user from './user'

import ColorBlind from './ColorBlind'

export default {
  headers: StyleSheet.create(headers),
  list: StyleSheet.create(list),
  form: StyleSheet.create(form),
  user: StyleSheet.create(user),
  ColorBlind
}



// WEBPACK FOOTER //
// ./src/components/Community/partials/UserEditor/style/index.js